var styleDataHash = "8eab96dc";
const injectCss = (() => {
  var css = `.CfRjk{border:0;height:100%;width:100%;z-index:0}.CfRjk,.fZkWY{left:0;position:absolute;top:0}.fZkWY{bottom:0;right:0;z-index:3}.x4vJP{height:0;padding-bottom:56.25%;position:relative}@supports not (contain:inline-size){@media only screen and (max-width:480px){.x4vJP{min-width:auto}}}@container (width < 480px){.x4vJP{min-width:auto}}.E3Ua8,.duFiJ{bottom:0;cursor:move;height:100%;position:absolute;top:0;width:100%;z-index:1}.E3Ua8{align-items:center;background:rgba(0,6,36,.7);display:flex;flex-direction:column;gap:12px;justify-content:center;padding:16px}.CcoZF{color:#fff}.E3Ua8~*>*,.duFiJ~*>*{pointer-events:none}.mJJ-4{height:0;overflow:hidden;visibility:hidden;width:0}.dXJ1F,.mJJ-4{position:absolute}.dXJ1F{align-items:center;background:rgba(0,0,0,.5);color:#fff;display:flex;font-size:20px;font-weight:400;height:100%;justify-content:center;right:0;text-align:center;top:0;width:100%;z-index:1}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var default_video_styles_default = {
  "video_player": "CfRjk",
  "videoOverlay": "fZkWY",
  "video_container": "x4vJP",
  "video_overlay": "duFiJ",
  "video_pending_overlay": "E3Ua8",
  "video_pending_overlay_loader": "CcoZF",
  "hide_duration": "mJJ-4",
  "error": "dXJ1F"
};
export {
  default_video_styles_default as default,
  injectCss
};
//# sourceMappingURL=default-video-styles-scss.js.map
